import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';
import {APP_PERMISSIONS} from '../../../data/permissions';

export const navConfig = (id?: string) => [
  {
    icon: 'tapybl-logo.svg', // icon: 'icon-ai_assistant_ic',
    title: getLocalizationBasedOnLang('Home', 'Hafan'),
    route: `/manage/${id}/home`,
    slug: 'ai-assistant',
    activeIcon: 'Home',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
  },
  {
    icon: 'icon-home-line',
    title: getLocalizationBasedOnLang('Workspace', 'Gweithle'),
    route: `/manage/${id}/workspace`,
    activeIcon: 'Home',
    slug: 'home',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_ACCESS_DASHBOARD,
  },
  {
    icon: 'icon-laptop',
    title: getLocalizationBasedOnLang('Library', 'Llyfrgell'),
    route: `/manage/${id}/library`,
    slug: 'nav-library',
    activeIcon: 'Page',
    permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
    reqireSubscription: true,
  },
  {
    icon: 'icon-lessons_ic',
    title: getLocalizationBasedOnLang('Microlessons', 'Microlessons'),
    route: `/manage/${id}/microlessons`,
    slug: 'microlessons',
    activeIcon: 'icon-lessons_ic',
    reqireSubscription: true,
    permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
  },
  {
    icon: 'icon-courses_ic',
    title: getLocalizationBasedOnLang('Courses', 'Cyrsiau'),
    route: `/manage/${id}/courses`,
    slug: 'courses',
    activeIcon: 'Course',
    permission: APP_PERMISSIONS.ORG_LIST_COURSES,
    reqireSubscription: true,
  },
  {
    icon: 'icon-users',
    title: getLocalizationBasedOnLang('Learners', 'Dysgwyr'),
    route: `/manage/${id}/learners`,
    slug: 'learners',
    activeIcon: 'Users',
    permission: APP_PERMISSIONS.ORG_LIST_LEARNERS,
    reqireSubscription: true,
  },
  {
    icon: 'icon-icon_analytics',
    title: getLocalizationBasedOnLang('Analytics', 'Analytics'),
    route: `/manage/${id}/analytics`,
    slug: 'analytics',
    activeIcon: 'Analytics',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_LIST_LEARNERS,
  },
  {
    icon: 'icon-settings',
    title: getLocalizationBasedOnLang('Settings', 'Gosodiadau'),
    route: `/manage/${id}/settings`,
    slug: 'settings',
    activeIcon: 'Settings',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_MANAGE_SETTINGS,
  },
];

export const helpConfig = {
  icon: 'icon-mail',
  title: getLocalizationBasedOnLang('Help & tutorials', 'Cymorth a thiwtorïau'),
  route: `https://help.tapybl.com/support/home`,
  slug: 'help',
  activeIcon: 'Help',
};

export const contactConfig = {
  icon: 'icon-annotation-question',
  title: getLocalizationBasedOnLang('Contact us', 'Cysylltwch â ni'),
  route: `https://help.tapybl.com/support/tickets/new?ticket_form=ask_a_question`,
  slug: 'mail',
  activeIcon: 'Mail',
};
